import { Button, Drawer, Form, Input, Select, Space } from "antd";
import { useEffect, useState } from "react";
import { IBattery } from "@drone-parts.garphild.pro/interfaces";
import { batteryTableColumns } from "../helpers/tables";
import ordersStorage from "../storages/orders.storage";
import { observer } from "mobx-react-lite";

/* eslint-disable-next-line */
export interface AddBatteryDialogProps {
  opened: boolean;
  onToggle: () => void;
}

export function AddBatteryDialog(props: AddBatteryDialogProps) {
  const { opened, onToggle } = props;
  const [battery, setBattery] = useState<IBattery>({
    _id: "",
    name: "",
    status: "",
    cellsCount: 0,
    linesCount: 0,
    capacity: 0,
    voltage: 0,
    price: 0,
    currency: "USD",
    description: "",
    parts: batteryTableColumns.map((column) => (
      {
        key: column.key,
        name: column.title,
        itemId: "",
        quantity: column.defaultQuantity || 0,
        price: 0,
        currency: "USD",
        total: 0,
      })),
  });
  const [searching, setSearching] = useState<{ [key: string]: string }>({});

  useEffect(() => {
    ordersStorage.loadOrders();
  }, []);

  return (
    <Drawer
      title={`Add Battery (Total: ${battery.parts.reduce((acc, item) => acc + item.total, 0).toFixed(2)})`}
      width={"50vw"}
      closable={true}
      onClose={onToggle}
      open={opened}
    >
      <pre style={{position: 'fixed', top: 0, left: 0, right: '50vw', maxHeight: '90vh', overflow: "scroll", backgroundColor: 'wheat', padding: 10, zIndex: 1}}>{JSON.stringify(battery, null, 2)}</pre>
      <Form.Item
        label="Name"
        name="name"
        labelCol={{ span: 5 }}
      >
        <Input
          placeholder="Name"
        />
      </Form.Item>
      <Form.Item
        label="Status"
        name="status"
        labelCol={{ span: 5 }}
      >
        <Input
          placeholder="Status"
        />
      </Form.Item>
      <Form.Item
        label="Cells"
        name="cellsCount"
        labelCol={{ span: 5 }}
      >
        <Input
          placeholder="Cells"
          type="number"
          value={battery.cellsCount}
          onChange={(e) => {
            try {
              const accPartType = battery.parts.find((item) => item.key === 'accumulators');
              const accQty = +e.target.value * battery.linesCount;
              if (accPartType) {
                accPartType.quantity = accQty;
                accPartType.total = accPartType.price * accPartType.quantity;
              } else {
                battery.parts.push({
                  key: 'accumulators',
                  name: 'Accumulators',
                  itemId: '',
                  quantity: accQty,
                  price: 0,
                  currency: 'USD',
                  total: 0,
                });
              }
              const newData = {
                ...battery,
                cellsCount: +e.target.value,
                parts: [...battery.parts],
              };
              setBattery(newData);
            } catch (e) {
              console.error(e);
            }
          }}
        />
      </Form.Item>
      <Form.Item
        label="Lines"
        name="linesCount"
        labelCol={{ span: 5 }}
      >
        <Input
          placeholder="Lines"
          type="number"
          value={battery.linesCount}
          onChange={(e) => {
            try {
              const accPartType = battery.parts.find((item) => item.key === 'accumulators');
              const accQty = +e.target.value * battery.cellsCount;
              if (accPartType) {
                accPartType.quantity = accQty;
                accPartType.total = accPartType.price * accPartType.quantity;
              } else {
                battery.parts.push({
                  key: 'accumulators',
                  name: 'Accumulators',
                  itemId: '',
                  quantity: accQty,
                  price: 0,
                  currency: 'USD',
                  total: 0,
                });
              }
              const newData = {
                ...battery,
                linesCount: +e.target.value,
                parts: [...battery.parts],
              };
              setBattery(newData);
            } catch (e) {
              console.error(e);
            }
          }}
        />
      </Form.Item>
      <Form.Item
        label="Capacity"
        name="capacity"
        labelCol={{ span: 5 }}
      >
        <Input
          placeholder="Capacity"
          type="number"
        />
      </Form.Item>
      {/*<Form.Item*/}
      {/*  label="Voltage"*/}
      {/*  name="voltage"*/}
      {/*  labelCol={{ span: 5 }}*/}
      {/*>*/}
      {/*  <Input*/}
      {/*    placeholder="Voltage"*/}
      {/*    type="number"*/}
      {/*  />*/}
      {/*</Form.Item>*/}
      <Form.Item
        label="Price"
        name="price"
        labelCol={{ span: 5 }}
      >
        <Input
          placeholder="Price"
          type="number"
        />
      </Form.Item>
      <Form.Item
        label="Currency"
        name="currency"
        labelCol={{ span: 5 }}
      >
        <Input
          placeholder="Currency"
        />
      </Form.Item>
      <Form.Item
        label="Description"
        name="description"
        labelCol={{ span: 5 }}
      >
        <Input
          placeholder="description"
        />
      </Form.Item>
      <hr />
      {batteryTableColumns.map((column) => {
        const part = battery.parts.find((item) => item.key === column.key);
        return (
          <>
            <Form.Item
              key={column.key}
              label={column.title}
              labelCol={{ span: 5 }}
            >
              <Space>
              <Select
                placeholder={column.title}
                style={{ width: 400 }}
                allowClear
                showSearch
                filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                onSearch={(value) => {
                  setSearching({
                    ...searching,
                    [column.key]: value,
                  });
                }}
                onChange={(value) => {
                  const partIndex = battery.parts.findIndex((item) => item.key === column.key);
                  const item = ordersStorage.items.find((item) => item._id === value);
                  if(partIndex < 0 || !item) {
                    return;
                  }
                  const part = battery.parts[partIndex];
                  const price = (item.itemPrice || 0) / (item.itemQuantity || 1) / (item.unitsInPackage || 1);
                  battery.parts[partIndex] = {
                    ...battery.parts[partIndex],
                    itemId: item._id || '',
                    name: item.itemText,
                    price,
                    total: price * part.quantity,
                  };
                  setBattery({
                    ...battery,
                    parts: [...battery.parts],
                  });
                }}
                value={part?.itemId}
                defaultValue={part?.itemId}
                options={
                  ordersStorage
                    .productsInStock
                    .filter((item) => {
                      if (part?.itemId && item._id === part?.itemId) {
                        return true;
                      }
                      if (!column.categories?.includes(item.category || "")) {
                        return false;
                      }
                      if (!column.enabled) {
                        return false;
                      }
                      if (!column.parts?.includes(item.part || "")) {
                        return false;
                      }
                      return true;
                    })
                    .map((item) => {
                      const name = item.shortName || `${item.itemText} / ${item.itemVariant}`;
                      const inStock = item.inStock || 0;
                      const orderDate = item.orderDate;
                      const usedItemsCount = item.used?.reduce((acc, usedItem) => acc + usedItem.quantity, 0) || 0;
                      return { label: `${item.received ? "": "(Not received)"}${orderDate?.toISOString()} - ${name} : ${inStock - usedItemsCount} (${item.itemPrice}}`, value: item._id }
                    })
                }
              />
              <Input
                type="number"
                step={column.step || 1}
                placeholder={"Quantity"}
                defaultValue={part?.quantity}
                value={part?.quantity}
                onChange={(e) => {
                  if (!part) return;
                  const quantity = (+e.target.value) || 1;
                  const price = part?.price || 0;
                  const newDronePart = {
                    ...part,
                    quantity: quantity,
                    total: Math.round((quantity * price) * 100) / 100,
                  };
                  const parts = [...battery.parts];
                  const index = parts.findIndex((item) => item.key === column.key);
                  parts[index] = newDronePart;
                  setBattery({
                    ...battery,
                    parts: parts,
                  });

                }}
              />
                <Space>{part?.total}</Space>
              </Space>
            </Form.Item>
          </>
        );
      })}
      <hr />
      <Form.Item
        label="key"
        labelCol={{ span: 5 }}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="Name"
        labelCol={{ span: 5 }}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="Item"
        labelCol={{ span: 5 }}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="Quantity"
        labelCol={{ span: 5 }}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="Price"
        labelCol={{ span: 5 }}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="currency"
        labelCol={{ span: 5 }}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="total"
        labelCol={{ span: 5 }}
      >
        <Input />
      </Form.Item>
      <Button>Add new item</Button>


      {/*batteryTableColumns
        .filter((battery) => battery.enabled !== false)
        .map((column) => {
          let batteryPart = batteryParts.find((item) => item.key === column.key);
          switch (column.type) {
            case ColumnTypes.delimiter:
              return <div key={column.key} style={{ height: 0, border: '1px dashed black', marginTop: 20, marginBottom: 20, position: "relative", display: 'flex', justifyContent: 'center' }}>
                <div style={{position: "absolute", top: -12, fontWeight: 'bold', backgroundColor: 'white', padding: "0 10px"}}>{column.title}</div>
              </div>;
            case ColumnTypes.select:
              return (
                <>
                  <Form.Item
                    key={column.key}
                    label={column.title}
                    name={column.key}
                    labelCol={{ span: 5 }}
                  >
                    <Select
                      placeholder={column.title}
                      allowClear
                      showSearch
                      filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                      onSearch={(value) => {
                        console.log("Search", value, column.key, searching);
                        setSearching({
                          ...searching,
                          [column.key]: value,
                        });
                      }}
                      onChange={(value) => {
                        console.log("Change", value, column.key, searching);
                        if (!value) {
                          const itemIndex = batteryParts.findIndex((item) => item.key === column.key);
                          if (itemIndex !== -1) {
                            const parts = [...batteryParts];
                            parts.splice(itemIndex, 1);
                            setBatteryParts(parts);
                          }
                          return;
                        }
                        const item = ordersStorage
                          .productsInStock
                          .find((item) => item._id === value);
                        if (!item) {
                          return;
                        }
                        let quantity = 1;
                        const price = item.itemPrice || 1;
                        if (batteryPart === undefined) {
                          setBatteryParts(
                            [...batteryParts, {
                              name: item.itemText,
                              key: column.key,
                              itemId: item._id?.toString() || "",
                              quantity: 1,
                              price: price,
                              currency: item.itemCurrency || "USD",
                              total: Math.round((quantity * price) * 100) / 100,
                            }]
                          );
                        } else {
                          quantity = batteryPart.quantity;
                          batteryPart = {
                            key: column.key,
                            name: item.itemText,
                            itemId: item._id?.toString() || "",
                            quantity: quantity,
                            price: price,
                            currency: item.itemCurrency || "USD",
                            total: Math.round((quantity * price) * 100) / 100,
                          };
                          const parts = [...batteryParts];
                          const index = parts.findIndex((item) => item.key === column.key);
                          parts[index] = batteryPart;
                          setBatteryParts(parts);
                        }
                      }}
                      value={batteryPart?.itemId}
                      defaultValue={batteryPart?.itemId}
                      options={
                        ordersStorage
                          .productsInStock
                          .filter((item) => {
                            if (batteryPart?.itemId && item._id === batteryPart?.itemId) {
                              return true;
                            }
                            if (!item.received) {
                              return false;
                            }
                            if (!column.categories?.includes(item.category || "")) {
                              return false;
                            }
                            if (!column.enabled) {
                              return false;
                            }
                            if (!column.parts?.includes(item.part || "")) {
                              return false;
                            }
                            if ((item.inStock || 0) <= 0) {
                              return false;
                            }
                            const usedItemsCount = item.used?.reduce((acc, usedItem) => acc + usedItem.quantity, 0) || 0;
                            if ((item.inStock || 0) <= usedItemsCount) {
                              return false;
                            }
                            return true;
                          })
                          .map((item) => {
                            const name = item.shortName || `${item.itemText} / ${item.itemVariant}`;
                            const inStock = item.inStock || 0;
                            const orderDate = item.orderDate;
                            const usedItemsCount = item.used?.reduce((acc, usedItem) => acc + usedItem.quantity, 0) || 0;
                            return { label: `${orderDate?.toISOString()} - ${name} : ${inStock - usedItemsCount} (${item.itemPrice}}`, value: item._id }
                          })
                      }
                    />
                  </Form.Item>
                  {batteryPart && (
                    <Form.Item
                      key={`${column.key}-qty`}
                      label={"Quantity"}
                      name={`${column.key}-qty`}
                    >
                      <Input
                        type="number"
                        step={column.step || 1}
                        placeholder={"Quantity"}
                        defaultValue={batteryPart?.quantity}
                        value={batteryPart?.quantity}
                        onChange={(e) => {
                          if (!batteryPart) return;
                          const quantity = (+e.target.value) || 1;
                          const price = batteryPart?.price || 1;
                          const newDronePart = {
                            ...batteryPart,
                            quantity: quantity,
                            total: Math.round((quantity * price) * 100) / 100,
                          };
                          const parts = [...batteryParts];
                          const index = parts.findIndex((item) => item.key === column.key);
                          parts[index] = newDronePart;
                          setBatteryParts(parts);

                        }}
                      />
                    </Form.Item>
                  )}
                  {batteryPart && <Form.Item>{batteryPart?.price.toFixed(2)} * {batteryPart?.quantity} = {batteryPart?.total}</Form.Item>}
                </>
              );
          }
        })*/}
    </Drawer>
  );
}

export default observer(AddBatteryDialog);
